module.exports = __webpack_public_path__ + "static/media/ic205editwithnewprice.514ea45e.jpg";